import { memo } from 'react';
import { Box, Image, ScrollView } from '@betty/moonlight';
import PromoTerms from '../PromoTerms/PromoTerms';
import RefferalPromoSummary from '../ReferrerPromoSummary/ReferrerPromoSummary';
import { Promotion } from '../../state/promos/promos.types';

function ReferrerPromoDetails({ promo }: { promo: Promotion }) {
  return (
    <ScrollView
      contentContainerStyle={{
        paddingBottom: 'safe-area-inset-bottom',
        width: '100%',
        maxWidth: 600,
        marginHorizontal: 'auto',
      }}
      showsHorizontalScrollIndicator={false}
    >
      <Box>
        <Box flex={1}>
          <Image
            source={promo?.imageUrl}
            width="100%"
            contentFit="cover"
            aspectRatio={2}
            borderRadius={{
              mobile: undefined,
              tablet: 'radius-400',
              desktop: 'radius-400',
            }}
          />
        </Box>
        <Box gap="space-200" padding="space-400">
          <RefferalPromoSummary
            title={promo.title}
            shortDescription={promo.shortDescription}
            refferalCode={promo.referralCode}
          />
          <PromoTerms
            description={promo.longDescription}
            termsAndConditions={promo.termsAndConditions}
          />
        </Box>
      </Box>
    </ScrollView>
  );
}

export default memo(ReferrerPromoDetails);
